'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./magiczoom/magiczoomplus'));
    processInclude(require('./magiczoom/magiczoom'));
});

